import { ShadowDialogue } from './ShadowDialogue';
import { ChatBottomBar } from './ChatBottomBar';
import type { Message } from './MessageBubble';
import type { Proposal, ProposalReviewActions } from './ProposalBubble';

interface ShadowPanelViewProps {
  messages: Message[];
  proposals: Proposal[];
  isLoading: boolean;
  error?: Error | null;
  disabled?: boolean;
  reviewActions?: ProposalReviewActions | undefined;
}

/**
 * Shadow Panel — параллельный диалог (read-only).
 *
 * Показывает:
 * - Header с иконкой и названием
 * - ShadowDialogue (client messages + proposals)
 * - ChatBottomBar в режиме status
 */
export function ShadowPanelView({
  messages,
  proposals,
  isLoading,
  error,
  disabled = false,
  reviewActions,
}: ShadowPanelViewProps): JSX.Element {
  return (
    <div className="flex-1 min-w-0 flex flex-col border-r border-border-subtle">
      {/* Header */}
      <div className="px-6 py-3 border-b border-border-subtle bg-accent-ai/5">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-full bg-accent-ai/20 flex items-center justify-center">
            <svg className="w-3 h-3 text-accent-ai" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <span className="text-sm font-medium text-accent-ai">Shadow</span>
          <span className="text-xs text-text-secondary">параллельный диалог</span>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        {disabled ? (
          <div className="flex flex-col items-center justify-center h-full text-text-secondary p-4">
            <p className="text-sm">Выберите чат</p>
          </div>
        ) : (
          <ShadowDialogue
            messages={messages}
            proposals={proposals}
            isLoading={isLoading}
            error={error ?? null}
            reviewActions={reviewActions}
          />
        )}
      </div>

      {/* Bottom Bar */}
      <ChatBottomBar
        mode="status"
        proposals={proposals}
        disabled={disabled}
      />
    </div>
  );
}
